let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("c8Z8I")).then(() => parcelRequire('aEOFr'));